module.exports = __webpack_public_path__ + "static/media/Waschküche_.2cc5215b.png";